import modalsData from '../redux/reducer/modalsData';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

export const useModalsDataActions = () => {
  const dispatch = useDispatch();
  return useMemo(
    () => ({
      addIdToShowedModal: (id) => dispatch(modalsData.actions.addIdToShowedModal(id)),
      removeShowedModal: (id) => dispatch(modalsData.actions.removeShowedModal(id)),
      setCallbacks: (obj) => dispatch(modalsData.actions.setCallbacks(obj)),
      addModal: (obj) => dispatch(modalsData.actions.addModal(obj)),
    }),
    [],
  );
};
